import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import store from "../../../store";
module.exports = {
    ...twLocale,
    netError: "網絡連接錯誤，請稍後重試",
    cancel:"取消",
    confirm:"確認",
    delete:"刪除",
    save:"保存",
    rename:"重命名",
    userSpace: "個人空間",
    entSpace: "企業空間",
    allUser: "所有用戶",
    frozen: "已凍結",
    upload: "上傳",
    import: "導入",
    tips: "提示",
    success: "成功",
    prompt: "提示",
    return: "返回",
    edit:"編輯",
    close: "關閉",
    noSearch: "搜索無結果",
    loadmore: "加載更多",
    retry: "重試",
    allDelete: "全部刪除",
    nextStep:"下一步",
    nodata:'沒有相關的查詢結果',
    back: "上一步",
    gotIt:"知道了",
    message:{
        addSuccess:'添加成功',
        deleteSuccess:'刪除成功',
        dismissSuccess:'解散成功',
        setSuccess:'設置成功',
        setFailed:'設置失败',
    },
    valid: { //校验
        noSpace: "空間大小不能為空",
        intSpace: "空間大小請輸入正整數",
        moreSpace: "不能超過企業總空間大小",
        moreData: "不能超過數據中心容量",
        noPwd: "密碼不能為空",
        limitWord: "長度為6-32個字符之間",
        manyWord: "6-32個字符，必須包含字母、數字、符號中的兩種",
        phone: "請輸入正確的手機號",
        noMail: "請輸入登錄郵箱",
        errorMail: "請輸入正確的郵箱格式",
        noName: "請輸入姓名",
    },
    log: {
        title: "日誌查詢",
        datearea: "時間",
        dateareaTip: "為了査詢效率，每次限査詢31天日誌",
        dateTo: "至",
        dateStart: "開始日期",
        dateEnd: "結束日期",
        logExport: "匯出日誌",
        category: "操作的類型",
        allCategory: "全部",
        action: "動作",
        allAction: "全部動作",
        space: "空間",
        allSpace: "全部空間",
        userSpace: "個人空間",
        entSpace: "企業空間",
        pathValue: "路徑關鍵字",
        pathValuePH: "請輸入路徑關鍵字",
        operator: "操作者",
        operatorPH: "按操作者査詢",
        optionOther: "附加篩選條件",
        search: "査詢",
        reset: "重置",
        time: "時間",
        actionName: "動作",
        object: "對象",
        detail: "詳情",
        ip: "IP地址",
        device: "設備",
        netError: "網絡連接錯誤，請稍後重試",
        logNull: "沒有找到相關日誌",
        logNull2: "請修改查詢準則後重試",
        userSearchNot: "沒有搜索到該操作者",
        userStrSize: "操作者最多可輸入50個字元",
        fileName: "文件",
        folderName: "文件夾",
        freeze: "凍結",
        team: "團隊",
        select: "選中",
        item: "項",
        nullData: "無"
    },
    logTimingExport:{
        title:"日誌定時導出",
        headInfo:"每個月月初定時導出上個自然月的日誌文件。日誌文件保留{year}年，請及時下載。",
        noLog:"還沒有生成日誌",
        openTimingExport:"已開啟定時導出日誌",
        closeTimingExport:"定時導出日誌已關閉",
        comfirmDelete:"您確定要刪除選中的日誌文件嗎？",
        deleteSuccess:"日志删除成功",
        delete:"删除",
        deleteLog:"删除日志",
        fileName:'文件名',
        creatTime:'生成時間',
        operation:'操作',
        download:'下載',
        batchDownload:'批量下載',
        logExportLanguage:'導出日誌語言',
        logExportLanguageTips:'語言切換成功，下次導出時生效'
    },
    fileTemp:{
        fileTemptitle:"文件模板",
        fileTempType:"模板類型",
        newFileTempType:"新建模板類型",
        searchPlaceholder:"搜索模板關鍵詞",
        typeManage:"類型管理",
        addTemp:" 添加模板",
        editTemp:" 編輯模板",
        all:"全部",
        defaultType:"默認類型",
        tempTypeName:"模板名稱",
        DC:"所屬數據中心",
        tempTeam:"適用團隊",
        state:"狀態",
        pbliushT:"已發佈",
        pbliushF:"未發佈",
        edit:"編輯",
        publish:"發佈",
        repeal:"撤銷",
        deleteTemp:"刪除模板",
        more:"更多",
        top:"置頂",
        cancelTop:"取消置頂",
        topword:"Top",
        deleteTempTips:"確認要刪除當前模板嗎？",
        allTeam:"全部團隊",
        operate:"操作",
        typeName:"類型名稱",
        typeNamePlaceholder:"請輸入類型名稱",
        tempTypeMaxNum:"模板類型數量已達上限，無法繼續創建",
        tempMaxNum:"模板數量已達上限，無法繼續創建",
        notNull:"並不能為空或空格",
        strReg:"不能包含以下字符/\\:*?\"<>|",
        max10:"最多輸入10個字",
        tempPlaceHolder:"請輸入模板名稱",
        tempTypePlaceHolder:"請選擇模板類型",
        teamPlaceHolder:"請選擇團隊",
        selectFile:"選擇文件",
        amend:"修改",
        selectFromPan:"選擇網盤文件",
        teamNotNull:"還沒有添加任何團隊",
        fileNotNull:"請選擇文件",
        sizeReg:"文件大小不能超過50M",
        viriusFile:"該文件包含病毒，不可使用",
        tempTypeManage:"模板類型管理",
        addType:"添加類型",
        deleteTitle:"刪除模板類型",
        deleteTypeTips1:"即將刪除的模板類型存在模板文件,",
        deleteTypeTips2:"請選擇模板文件的處理方式",
        deleteTypeTips3:"只刪除模板類型，模板文件將移動到默認類型中",
        allDelete:"一併刪除",
        onlyTypeDelete:"僅刪除類型",
        publishSuccess:"發佈成功",
        topSuccess:"置頂成功",
        cancelTopSuccess:"取消置頂成功",
        repealSuccess:"撤銷成功",
        saveSuccess:"保存成功",
        searchNull:"沒有搜索到～",
        listNull:"文件模板列表為空"
    },
    offline: {
        masterSwitchTitle: "離綫文檔管控",
        encryptModeTitle: "密鑰模式：",
        encryptEntMode: "企業加解密",
        encryptEntModeTip: "下載的加密文件企業內的成員都可以解密",
        encryptAccountMode: "賬戶加解密",
        encryptAccountModeTip: "下載的加密文件僅下載者可以解密",
        LinkModeTitle: "文檔管控規則：",
        approvalLinkMode: "創建鏈接需審批",
        banLinkMode: "禁止鏈接",
        switchEncryptTip: "切換秘鑰模式會導致之前下載的文件無法解密，請確認是否繼續？",
        submit: "提交",
        cancel: "取消",
        confirm: "確定",
        confirmTitle: "提示",
        submitSuccess: "提交成功",
        hotLine: "聯繫客服開通服務，請撥打：400-898-7968",
        offlineTip: "網絡問題，請重新嘗試提交",
        selectedSummary: "共{personNum}個成員，{teamNum}個團隊",
        selectedSummaryEnt: "共{personNum}個成員，{teamNum}個團隊，{orgNum}個組織",
        controlUser: "添加管控成員",
        directory: "共{0}個目錄",
        belongTeam: "等{0}個團隊",
        copymove: "管控目錄的文件",
        linkApprover: '鏈接審批者',
        linkApproverInput: '輸入用戶名或郵箱，最多可設置5個審批者',
        linkApproverTips: '如果未指定審批者，則遵循{str}',
        linkApproverTipsInsert: '默認審批者邏輯',
        approverDialogTitle: '默認審批者邏輯',
        readyApproverTips: '未指定審批者，遵循默認審批者邏輯',
        approverLogic1:'1.普通成員創建外鏈，默認審批者為該文件的最近的{admin}。',
        approverLogic2:'2.如果創建外鏈者是該外鏈文件的{admin}，則默認審批者為最近的上級{admin}。',
        approverLogic3:'3.創建外鏈的文件無{admin}，默認審批者為網盤管理員。',
        approverLogic4:'最近的定義：逐級遞歸向上找上壹級的{admin}，直至網盤管理員。',
        notes:'註：',
        approverDocAdmin: '文檔管理員',
        approverTeamAdmin: '團隊管理員',
        forbiddenCopymove:'禁止移動/復制',
        forbiddenCopymoveTip:'勾選禁止移動/復制後，通過客戶端下載的管控文件只能通過客戶端回傳到原目錄',
        forbiddenCopymove1: '您確定要取消“禁止移動/復制”選項嗎？',
        forbiddenCopymove2: '取消後有權限的用戶可能將該目錄內文件移動/復制到其他目錄跳過指定審批',
        copymoveTip: "管控目錄內的文件以及所有上級目錄均受到限制（管控目錄內的文件路徑，所有層級均受到限制）",
        maxWhite: "白名單成員不能超過{0}人",
        maxDir: "白名單目錄不能超過{0}條",
        defaultApprovers: '默認審批者',
        etc:'{name}等{num}人',
        approvalRule:'受管控對象從企業空間發送外鏈時，除以下審批規則外都遵從{rule}進行審批，防止文件泄露',
    },
    memberControl: {
        noTeamSearch: "沒有相應的團隊和成員",
        noUserSearch: "沒有相應的成員",
        existTip: "不能重複選擇同一個人或者團隊",
        existToast: "不能重复选择同一個人",
        maxLenTip: "添加失敗，團隊或成員超出上限",
        controlList: "受管控成員 ：",
        whiteList: "管控白名單：",
        partMember: "部分團隊/成員",
        partMemberEnt: "部分團隊/組織/成員",
        allMember: "所有成員",
        noControlList: "還未添加管控成員/團隊",
        noControlListEnt: "還未添加管控成員/團隊/組織",
        noWhiteList: "還未添加管控白名單成員",
        frozon: "已凍結",
        selectedSummary: "已管控{teamNum}個團隊，{personNum}個成員",
        selectedSummaryEnt: "已管控{teamNum}個團隊，{orgNum}個組織, {personNum}個成員",
        selectedMemberSummary: "已選{personNum}個成員",
        searchPlaceholder: "搜索團隊名、用戶名或郵箱",
        searchMemberPlaceholder: "搜索用戶名或郵箱",
        dialogTitle: "選擇團隊/成員",
        dialogVerSelectedMemberSummary: "已加入白名單({personNum})"
    },
    controlDictionary: {
        title: "請搜索或選擇團隊/成員",
        searchPlaceholder: "搜索用戶名、郵箱或團隊名",
        searchOrgTeam: "搜索用戶名、郵箱或組織名",
        selectedSummary: "已選擇{teamNum}個團隊，{personNum}個成員",
        selectedSummaryEnt: "已選擇{teamNum}個團隊，{orgNum}個組織，{personNum}個成員",
        noMemberAdded: '請選擇團隊/成員加入',
        noMemberEnt: '請選擇團隊/組織/成員加入',
        selectAll: "全選",
        searchSelectedSummary: "已選中 {n}項",
        noResult: "搜索無結果",
        addButton: "添加",
        category: "類別：",
        teamUser: "團隊和成員",
        orgUser: "組織和成員",
    },
    edas: {
        title: '企業賬戶認證服務配置',
        subHeader: '您可以將開放平臺與企業域對接，快速導入及同步企業已有用戶和組織架構。',
        importServerConfig: '組織導入服務配置',
        sync: '組織導入服務配置',
        authServerConfig: '登錄認證服務配置',
        auth: '登錄認證服務配置',
        agentName: '代理名稱',
        serviceName: '服務名稱',
        serial: '序列號',
        ctime: '創建時間',
        status: '狀態',
        authentication: '企業認證服務配置',
        operation: '操作',
        addAgentServer: '添加服務代理',
        cancel: '取消',
        confirm: '確定',
        next: '下一步',
        last: '上一步',
        serviceList: '服務清單',
        all: 'Select all',
        addServerConfig: '添加服務配置',
        editServerConfig: '编辑服务配置',
        // serverType: '服务器类型',
        autoSyncTime: '自動同步時間',
        lastSyncTime: '上次同步時間',
        newAgentSrver: '新建代理服務',
        unbound: '解除綁定',
        delete: '刪除',
        unbind: '未綁定',
        normal: '正常',
        disconnect: '斷開',
        //hasAddAgentServer: '代理服務已添加',
        unboundTips: '解除綁定後，該代理服務不可用，是否繼續解除？',
        confirmUnbound: '繼續解除',
        deleteTips: '刪除後，該服務將解綁並清除相關參數，是否繼續？',
        tips: '提示',
        serviceType: '服務類型',
        // agentServer: '代理服务',
        ad: 'AD',
        corpWX: '企業微信',
        dingding: '釘釘',
        none: '無',
        submit: '提交',
        connectConfig: '連接配置',
        serviceAddress: '服務器地址',
        serviceManageAccount: '服務器管理賬號',
        password: '密碼',
        baseDN: 'Base DN',
        port: '端口',
        corpId: 'corpid',
        appId: 'appId',
        corpSecret: 'corpSecret',
        ProviderSecret: 'ProviderSecret',
        secret: 'secret',
        appKey: 'appKey',
        appSecret: 'appSecret',
        fieldMapping: '字段映射',
        userID: '用戶標識字段',
        userNameField: '用戶名稱字段',
        emailField: '用戶郵箱字段',
        mobileField: '用戶手機字段',
        login: '用戶登錄字段',
        teamID: '團隊標識字段',
        teamName: '團隊名稱字段',
        allowMailImportToBeEmpty: '郵件導入允許為空',
        mailImportToolTip: '如果去掉勾選，及不允許為空，則郵箱為空的用戶不導入',
        customField: '自定義字段',
        lenovoboxField: '網盤字段',
        importField: '導入字段',
        addField: '添加字段',
        syncConfig: '同步配置',
        defaultImportMode: '默認導入方式',
        allImport: '全部導入',
        allNoImport: '全部不導入',
        syncTime: '同步執行時間',
        accordingDay: '按天',
        accordingHour: '按時',
        hour: '時',
        min: '分',
        hours: '時',
        mins: '分',
        LDAP: 'LDAP',
        ADFS: 'ADFS',
        adfsCertificate: 'adfs证书 (jks格式)',
        certificatePassword: '證書密碼',
        adfsAddress: 'ADFS地址',
        callBackUrl: 'CallbackURL',
        everyday: '每天',
        every: '每',
        syncOperation: '立即同步',
        log: '日誌',
        more: '更多',
        setServiceConfig: '設置服務配置',
        setFiltrationConditions: '設置過濾條件',
        deleteSuccess: '刪除成功',
        back: '返回',
        syncCompleteTime: '同步完成時間',
        syncSuccess: '同步成功',
        syncFail: '同步失敗',
        unSync: '未同步',
        unSyncToolTip: '通過黑名單過濾未同步的數據',
        detail: '詳情',
        export: '導出',
        syncDetail: '同步詳情',
        object: '對象',
        action: '動作',
        detailSyncTime: '同步時間',
        allSyncResult: '全部同步結果',
        failReasons: '失敗原因',
        success: '成功',
        fail: '失敗',
        user: '用戶',
        team: '團隊',
        created: '創建',
        update: '更新',
        frozen: '凍結',
        unfrozen: '解凍',
        filter: '已過濾',
        unSyncUser: '未同步用戶',
        unSyncTeam: '未同步團隊',
        unSyncOrganization:'未同步組織',
        netError: "網絡連接錯誤，請稍候重試",
        importServiceConfigCuccess: '添加導入服務配置成功！',
        filterInquiry: '是否立即去設置導入過濾條件？',
        noSettings: '暫不設置',
        goSettings: '前往設置',
        setFilter: '設置過濾條件',
        addFilter: '添加條件',
        addFilterCondition: '添加過濾條件',
        modifyFilterCondition: '修改過濾條件',
        batchImport: '批量導入',
        userEmail: '用戶郵箱',
        userPhone: '用戶手機',
        userName: '用戶名稱',
        teamUser: '團隊名稱',
        filteringContent: '過濾內容',
        allConditionalType: '全部條件類型',
        allFilterMode: '全部過濾方式',
        import: '導入',
        noImport: '不導入',
        modify: '修改',
        conditionalType: '條件類型',
        filterMode: '過濾方式',
        importModeDesc: '導入方式可在服務配置中修改',
        addedNumber: '已添加',
        addedText: '個條件',
        first: '第一步',
        downloadTemp: '下載模板',
        downloadTempDesc: 'xls或xlsx文件',
        second: '第二步',
        editedUpload: '編輯內容後，上傳',
        upload: '上傳',
        edit: '編輯',
        uploadCertificate: '上傳證書',
        deleteItem: '刪除選中項',
        selectedText: '確定選中刪除的',
        importLogTitle: '導入服務配置列表',
        mostNumber: '最多10條字段',
        enterLenovoboxField: '請輸入網盤字段',
        enterImportField: '請輸入導入字段',
        hasAddAgentServer: '代理服務已添加',
        agentRelease: '代理綁定已解除',
        noServiceConfig: '未添加服務配置',
        noAgentService: '未添加代理服務',
        syncConfigDesc: '提交後，可添加過濾條件篩選部分用戶',
        noDetailResulr: '沒有相應的搜索結果',
        filterTitleTip: '默認導入全部數據，可設置全部不導入，通過添加條件來導入部分數據',
        importAcount: '總計導入',
        condition: '個條件',
        copy: '複製',
        copySuccess: '複製成功',
        copyFail: '複製失敗',
        serviceNamePlaceholder: '請輸入服務配置名稱，最多50個字符',
        serviceAddressPlaceholder: '例如：120.22.100.11',
        manageAccountPlaceholder: '請輸入將要連接的服務器管理員賬號',
        enterPasswordPlaceholder: '請輸入密碼',
        enterSearchValue: '請輸入搜索內容',
        selectFilterType: '請選擇過濾條件類型',
        enterEmail: '請輸入用戶郵箱',
        enterUserPhone: '請輸入用戶手機',
        enterUserName: '請輸入用戶名稱',
        enterTeamName: '請輸入團隊名稱',
        noSearchResult: '請換個關鍵詞再試試',
        loadMore: '加載更多',
        beyondLimit: '超出10000條上限',
        configSuccess: '配置成功',
        deleteConfirm: '確認刪除？',
        item: '个',
        items: '項',
        noFilterSearchResult: '無相應的搜索結果，請換個關鍵詞再試試',
        character: '請輸入服務配置名稱，最多50個字符',
        noErrorSpecialCharacters: '不允許輸入以下特殊字符"\\/:*?"<>|"',
        isSyncing: '執行同步中',
        jksFile: 'jks格式',
        uploadJksFile: '請上傳jks格式文件',
        inputCertificatePassword: '請輸入證書密碼',
        address: '請輸入地址',
        modifySuuccess: '修改成功',
        agentPlaceholder: '請輸入代理服務名稱，最多50個字符',
        inputTeamOrUser: '輸入用戶名/團隊搜索',
        addFilterSuccess: '添加過濾條件成功',
        modifyFilterSuccess: '修改過濾條件成功',
        errorEmail: '郵箱格式不正確',
        errorMobile: '手機格式不正確',
        agentId: 'agentId',
        bindingServerConfig: '第三方綁定服務配置',
        matchingRule: '匹配規則',
        mobile: '手機號',
        email: '郵箱',
        syncResult: '同步結果',
        newBinding: '新綁定',
        failBinding: '綁定失敗',
        account: '賬號',
        bindingLogTitle: '綁定配置的日誌列表',
        inputAccount: '請輸入賬號',
        weaver:'泛微',
	    weaverOA:'泛微OA',
        customize: '自定義',
	    URL:'URL',
        urlTip:'請輸入帶http://或https://的URL',
        departmentID: '部門標識字段',
        departmentName: '部門名稱字段',
        parentDepartment:'父部門',
        agentTips:'當前服務類型無需選擇代理名稱',
        syncMode: '同步方式',
        syncOrganization: '同步到組織',
        syncTeam: '同步到團隊',
        syncUserOnly: '僅同步用戶',
        syncOrganizationToolTip: '將對接系統的組織和人員同步到網盤組織中',
        syncTeamToolTip: '將對接系統的人員同步到組織下，將對接系統的組織結構同步到團隊中',
        syncTeamToolTipNotEnterPrise: '將對接系統的組織結構同步到團隊中',
        syncUserOnlyToolTip: '僅將對接系統的人員同步到組織根節點下，不同步組織',
        syncUserOnlyToolTipNotEnterPrise: '僅將對接系統的人員同步到團隊根節點下，不同步組織',
        remarks: '備註',
        move: '移動',
        organization:'組織',
        mostCustomNumber: '最多{0}條字段',
        createAgentFirst: '請先配置代理服務',
        hasNoAgentNow: '暫無代理服務',
        notNeedAgent: '當前服務類型無需選擇代理名稱',
        connectFieldName: '連接配置項名稱',
        connectFieldContent: '連接配置項內容',
        enterConnectFieldName: '請輸入連接配置項名稱',
        enterConnectFieldContent: '請輸入連接配置項內容',
        signCongit: "掃碼登入服務配寘",
        SSO: "單點登錄（SSO）服務配寘",
        sso: "單點登錄（SSO）服務配寘",
        searchSuccess: '査詢成功',
        allSuccess:'Success',
        startSuccess:'Success',
        closeSuccess:'Success',
        uploadSuccess:'Success',
        scanName: '登錄名',
        boxUrl: '網盤訪問地址',
        copyUrl: '複製地址',
        identification: '匹配標識',
        appKeySecret: 'appKeySecret',
        ssoWarning: '由於您使用了代理服務，系統無法獲取到代理伺服器地址，囙此請您在使用網盤訪問地址時，需手動將代理服務的IP或地址填寫在xxx位置，例如：https://lenovows.com/user/manage',
        agentWarning: '代理服務最多添加1個配寘',
        importWarning: '組織導入服務最多添加1個配寘',
        authWarning: '登入認證服務最多添加1個配寘',
        schema: 'schema',
        userStatus: '使用者狀態',
        probation:'試用',
        formal:'正式',
        temporary:'臨時',
        probationExtension:'試用延期',
        dismissal:'解聘',
        resignation:'離職',
        retirement:'退休',
        invalid:'無效，只同步正式用戶',
        importSealTeam:'導入封存團隊',
        yes:'是',
        no:'否',
        relationship: '關係',
        appIdMobile: 'appIdMobile',
        appSecretMobile: 'appSecretMobile',
        applicationVoucher:'應用憑證',
        applicationVoucherTitle:'配寘連接釘釘的應用憑證，用於獲取釘釘用戶的基礎資訊',
        scanLogin:'掃碼登入',
        qrcode:'掃碼登入',
        scanLoginTitle:'配寘釘釘掃碼登入應用授權資訊，以實現釘釘掃碼登入網盤',
        mobileAuthorizedLogin:'移動端授權登入',
        mobileAuthorizedLoginTitle:'配寘釘釘“移動應用接入-分享”授權資訊，以實現移動端可以通過釘釘授權登入',
        kingdee: '金蝶雲',
        createSuperiorTeam: '自動創建上級團隊',
        createSuperiorOrg: '自動創建上級組織',
        autCreateSuperiorTeam: '添加的過濾條件同步到團隊時自動創建上級團隊',
        autCreateSuperiorOrg: '添加的過濾條件同步到組織時自動創建上級組織',
        ...store.getters['tw']
    },
    addUser: {
        title: "添加成員",
        searchLable: "請搜索或選擇成員：",
        searchInput: "搜索用戶名、郵箱或組織名",
        allSelected: "共{0}個成員",
        selected: "已選擇{0}個成員",
        selectJoin: "請選擇成員加入",
        continue: "添加現有成員，將變更用戶的組織關係，是否繼續？",
    },
    batchImport: {
        bulk: "批量導入用戶",
        title: "批量添加用戶",
        downloadTemp: "第一步：下載模版文件",
        editTemp: "第二步：編輯模版文件",
        uploadTemp: "第三步：上傳編輯好的文件",
        downloadBtn: "下載模版",
        fileType: "xls或xlsx文件",
        progress: "正在導入模板中的用戶，請稍候...",
        total: "總計{0}個用戶",
        upSuccess: "成功導入{0}個用戶",
        upFailed: "{0}個賬戶導入失敗",
        user: "用戶名",
        mail: "登錄郵箱",
        phone: "手機號碼",
        pwd: "密碼",
        org: "組織",
        state: "狀態",
        noFile: "還沒有上傳文件",
        errorType: "不能上傳{0}，文件類型不允許",
        emptyFile: "文件為空",
        upSuccessTip: "導入成功",
        more: "文件超過500M了，請使用",
        client: "客戶端",
        upload: "上傳",
        flashTip: "要使用該功能，您需要安裝Flash插件, 猛擊",
        here: "這裏",
        install: "安裝",
        force: "強制導入的用戶修改初始密碼"
    },
    createUser: {
        title: "添加用戶",
        org: "所屬組織：",
        mail: "登錄郵箱：",
        mailInput: "請輸入登錄郵箱",
        name: "姓名：",
        nameInput: "請輸入姓名",
        phone: "手機號：",
        date: "有效期：",
        setDate: "添加賬戶有效期",
        seletDate: "選擇日期",
        data: "數據中心：",
        space: "個人空間：",
        spaceInput: "請輸入空間大小",
        spaceTips: "不能超過總空間大小",
        active: "通過電子郵件發送激活鏈接，由用戶自行設置密碼",
        set: "由管理員設置密碼",
        pwdTips: "密碼6-32個字符，至少兩種字元組合",
        forbidPwd: "禁止賬戶修改密碼",
        allowPwd: "允許修改密碼",
        firstLoginPwd: "首次登錄修改密碼",
        success: "創建用戶成功",
        phonePlaceholder: "請輸入手機號碼",
        area:"搜索國家/地區",
        areaNull: "未找到相關國家或地區",
        seletDateTips: "超過此日期，該賬戶將無法登陸"
    },
    userSet: {
        title: "用戶設置",
        userType: "用戶類型：",
        sended: "已發送",
        active: "已激活",
        noactive: "未激活",
        sendEmail: "激活邀請",
        pwd: "登錄密碼：",
        setPwd: "修改登錄密碼",
        inputPwd: "請輸入密碼",
        team: "所屬團隊：",
        invitation: "邀請發送成功",
        invitationSuccess: "1小時內不可重複發送激活邀請",
        success: "用戶設置成功",
        noData: "該用戶個人空間已存有數據，無法更換數據中心？",
        confirmData: "如需更換，可遷移數據後重試",
        isData: "是否確定更換數據中心？",
        yesData: "更換數據中心後，已刪除的數據不可恢複",
        localUser: "本地認證用戶",
        entUser: "企業認證用戶",
        thirdUser: "第三方認證用戶",
        pwdTip:"第三方應用同步的用戶不支持設置密碼"
    },
    //管理员角色
    adminRole:{
        title: "管理員角色"
    },
    orgManage:{
        title: "組織管理",
        createUser:"創建新用戶",
        addLocalUser:"添加現有用戶",
        batchUser:"批量導入用戶",
        forze:"凍結",
        unforze:"解除凍結",
        batchSet:"批量設置",
        search:"輸入用戶名、郵箱搜索",
        userBatchSet:"賬戶批量設置",
        spaceErr:"空間大小請輸入正整數",
        deleteUserConfirm:"您確定要刪除選中的用戶嗎？",
        deleteUserConfirm2: "當前用戶個人空間沒有與他人共享的文件夾",
        deleteUserConfirm3: "刪除用戶會刪除其個人空間數據，並取消所有權限",
        deleteUserOdc:"該用戶為離線文檔管控中{0}目錄的唯壹鏈接審批者，刪除後，該目錄的鏈接審批規則將采用默認審批者邏輯。",
        deleteUserOdcMore:"該用戶為離線文檔管控中{0}等目錄的唯壹鏈接審批者，刪除後，該目錄的鏈接審批規則將采用默認審批者邏輯。",
        deleteUserApproval:"該用戶為{0}目錄審批規則的唯壹審批者，刪除後，該審批規則將采用默認審批者邏輯。",
        deleteUserApprovalMore:"該用戶為{0}等目錄審批規則的唯壹審批者，刪除後，該審批規則將采用默認審批者邏輯。",
        frozeUserOdc:"該用戶為離線文檔管控中{0}目錄的唯壹鏈接審批者，凍結後，該目錄的鏈接審批規則將采用默認審批者邏輯。",
        frozeUserOdcMore:"該用戶為離線文檔管控中{0}等目錄的唯壹鏈接審批者，凍結後，該目錄的鏈接審批規則將采用默認審批者邏輯。",
        frozeUserApproval:"該用戶為{0}目錄審批規則的唯壹審批者，凍結後，該審批規則將采用默認審批者邏輯。",
        frozeUserApprovalMore:"該用戶為{0}等目錄審批規則的唯壹審批者，凍結後，該審批規則將采用默認審批者邏輯。",
        //confirm:"確認",
        confirmDelete:"確定删除",
        spaceNullErr:"空間大小不能為空",
        addOrg:"添加組織",
        searchOrg:"搜索組織名稱",
        dissOrg:"解散組織",
        deleteOrg:"删除組織",
        renameOrg:"重命名組織",
        level:"所屬層級",
        orgName:"組織名稱",
        orgNamePlaceholder:"請輸入組織名稱，不超過128個字",
        dissOrgMsg:"您即將解散該組織",
        dissOrgMsg2:"該組織下的成員及子組織將自動歸屬到上一級組織",
        deleteOrgMsg:"您確定要删除組織嗎？",
        deleteOrgMsg2:"子組織和用戶將一併删除",
        searchOrgNull:"沒有搜到相關組織",
        selected:"已选中",
        members: "個成員",
        username: "用户名",
        email: "郵箱",
        ctime: "創建時間",
        etime: "到期時間",
        mobile: "手机号",
        dcId:'數據中心',
        quota:'個人空間',
        teamName:'所屬組織',
        exporting:"導出中",
        login_time:'最近登錄時間',
        cancel:"取消",
        confirm:"確認",
        all: "全部",
        inDay: "{0}天內",
        inDayOne: "{0}天内",
        userState:"帳戶狀態",
        opearte:"操作",
        operationSet:"用戶設置",
        operationMore: "更多",
        modifyEmail:"修改帳戶郵箱",
        deleteUser:"刪除用戶",
        orgNullUser:"當前組織下沒有成員",
        choiceNullUser:"没有相關用戶",
        loginEmial:"登錄郵箱",
        normal:"正常",
        frozen:"已凍結",
        unfrozen:"未凍結",
        activeted:"已激活",
        unactiveted:"未激活",
        emialChange:"郵箱修改為",
        deleteSuccess:"刪除成功",
        errorTextMax:"已達到可輸入字符上限",
        forzeConfirm:"凍結賬戶操作會使該賬戶無法登陸網盤，但其個人空間中的數據和團隊權限仍然保留。您確定要凍結該賬戶嗎？",
        unforzeConfirm:"確認要解除凍結選中的用戶嗎？",
        forzeApproval:"您確定要凍結賬戶嗎？",
        forzeSuccess:"解除凍結成功",
        personNum: "人",
        searchRolePlacehodler: "輸入要搜索的關鍵字",
        orgDeleteSuccess: "組織删除成功",
        export: '導出用戶',
        customDialogHeader:'自定義列表項',
        enterpriseCertifiedUsers:"企業認證用戶",
        thirdPartyCertifiedUsers:"第三方認證用戶",
        exportOutTime:'導出超時，請重試。',
        save:'確認',
    },
    adminList: {
        title: "管理員設置",
        singleDelete: "確定要刪除該管理員嗎？",
        multipleDelete: "確定要刪除選中的管理員嗎？",
        addAdmin: "添加管理員",
        editAdmin: "編輯管理員",
        adminAuth: "管理權限",
        authScope: "管控範圍",
        adminEmpty: "還沒有管理員",
        userName: "用戶名稱：",
        auth: "管理權限：",
        scope: "管控範圍：",
        posTeam: "指定團隊",
        allTeam: "全部團隊",
        posFile: "部分團隊文件",
        allFile: "全部文件",
        searchTeam: "搜索團隊名稱",
        noSearchTeam: "沒有搜索到相關團隊",
        control: "已管控{0}個團隊",
        addControl: "添加管控",
        nullControl: "還未添加管控團隊",
        selectUser: "請選擇一名用戶",
        noSelectAuth: "還沒有選擇權限",
        noSelectTeam: "還沒有選擇管控團隊",
        noAddTeam: "還沒有添加管控的團隊",
        addAdminOk: "添加管理員成功",
        chooseSame: "不能重複選擇同一個團隊",
        beyondlimit: "添加失败，管控團隊數量超出上限",
        selectAuthTip: "請點擊選擇權限",
        repeatAuth: "不能重複賦予同一權限",
        inputUser: "請輸入用戶名或郵箱",
        nullUser: "沒有搜索到相關用戶名稱",
        selectedTeam: "已選擇{0}個團隊",
        selectJoin: "請選擇團隊加入",
        searchNull: "沒有搜索到相關用戶",
        partFail: "部分删除失敗，請在列表中查看後重試",
        controlNum: "共{0}個管控團隊",
        controlTeamList: "團隊管控列表",
        controlledTeams: "管控的{0}個團隊：",
    },
    transferAuth: {
        title: "移交權限",
        searchTitle: "網盤成員",
        folderAuth: "文件夾共享成員",
        noAuth: "暫無共享成員",
        folders:"的{0}個共享文件夾",
        userTooltip:"所選用戶中有人擁有與他人共享的文件夾，您可以：",
        userTooltip2:"1.徹底刪除，清除其個人文件夾和共享文件夾數據",
        userTooltip3:"2.將其共享文件夾移交給網盤其他用戶",
        userTooltip4:"有{0}個人存在與他人共享文件夾",
        transfer: "移交並刪除",
        tips: '選擇的用戶{0}擁有與他人共享的文件夾',
        tipsOrg: '組織中存在{0}擁有與他人共享的文件夾',
        tips2:'刪除用戶會刪除其個人空間數據，並取消所有權限',
        tips3:'您可以：',
        tips4:'徹底刪除用戶將一併刪除共享文件夾',
        tips5:'您可以在刪除用戶同時，將共享文件夾移交給其他用戶',
        tips6:'請選擇移交的共享文件夾，沒有選擇的共享文件夾將被徹底刪除',
        selectUser:'已選中{0}個成員',
        deleted:'已刪除',
        transferDeleted:'已移交並刪除',
        delete:'徹底刪除',
        searchResult:'搜索結果：',
        folderUser:'文件夾共享成員',
        userNull:'沒有搜到相關成員',
        userSuccessTip:'用戶權限移交並刪除成功',
        userAllSuccess:'全部操作成功',
        userUserSuccess:'用戶刪除成功',
        userOtherSuccess: '部分操作已生效',
    },
    synctask:{
        title:'同步任務',
        tips:'將指定文件夾的文件，同步至其他數據中心，實現數據的歸檔',
        openservice: '聯繫客服開通服務，請撥打400-898-7968',
        choosefile: '請選擇文件夾',
        addtasktips: '您目前最多可添加{0}個同步任務',
        addtasktipshover: '每添加一個同步模塊，可添加{0}個同步任務',
        addtask: '添加同步任務',
        taskFolder: '同步文件夾',
        dataCenter: '所在數據中心',
        taskTo: '同步至',
        chooseDataCenter: '請選擇數據中心',
        syncTiming: '定時同步',
        chooseTime: '选择时间点',
        folder: '文件夾',
        syncDataCenter: '同步數據中心',
        createTime: '創建時間',
        creater: '創建者',
        taskState: '任務狀態',
        operate: '操作',
        notTask: '還沒有同步任務',
        editTask: '修改同步任務',
        syncFolder: '同步文件夾',
        deleteTask:'删除同步任務',
        confimTask: '確認删除這條同步任務嗎？',
        taskLog: '任務日誌',
        change: '更改',
        exception: '异常',
        normal: '正常',
        taskSuccess: '同步任務創建成功',
        taskChangeSuccess: '修改成功',
        notSameTime: '不能選擇同壹時間',
        noModules: '未檢測到同步模塊，請先部署同步模塊再添加任務',
    },
    app: {
        'thirdApp': '協力廠商應用',
        'appManager': '應用管理',
        'createApp': '創建應用',
        'editApp': '修改應用',
        'appName': '應用名稱',
        'appDesc': '應用描述',
        'appIcon': '應用圖標',
        'ipManage': 'IP管理',
        'addIp': '添加IP訪問',
        'appNameTip': '請輸入應用名稱，不超過50個字元',
        'addIpDesc': '填寫訪問此應用的IP，多個IP請以“，”隔開，支持填寫IP段，IP起始地址與終止地址使用“-”隔開',
        'rateLimit': '介面頻率限制',
        'setRateLimit': '設定介面頻率',
        'rateLimitDesc': '為防止應用程序頻繁調用而引發服務器負載异常，默認情况下，每個服務端介面調用都有頻率限制，當超過此限制時，調用對應介面時會返回對應錯誤碼。',
        'rateLimitNumber': '需要提示上限數位',
        'rateLimitUnit': '次/分鐘',
        'appVoucher': '應用憑證',
        'baseInfo': '基礎資訊',
        'appAvatar': '應用圖標',
        'editInfo': '編輯資訊',
        'backUp': '返回應用管理',
        'deleteApp': '删除應用',
        'voucher': '憑證與基礎資訊',
        'authManage': '許可權管理',
        'createSuccess': '創建成功',
        'createError': '創建失敗',
        'modifySuccess': '修改成功',
        'modifyError': '修改失敗',
        'delSuccess': '删除成功',
        'delError': '删除失敗',
        'modifyAuthSuccess': '批量設定成功',
        'modifyAuthError': '批量設定失敗',
        'deleteConfirm': '删除確認',
        'appNumLimit': '應用數量達到上限，無法繼續創建',
        'ipFormatError': 'IP範圍格式錯誤',
        'deleteConfirmTitle': '您確定要删除該應用嗎？',
        'deleteDesc': '請檢查應用資訊，删除後不可恢復，憑證將失效',
        'imgFormatLimit': '僅支持上傳JPG/PNG格式',
        'imgBulkLimit': '圖片必須小於120KB',
        'imgSizeLimit': '圖片必須為240*240px以上',
        'imgTip': '請上傳JPG/PNG格式、240*240px以上、1:1、120kb以內的無圓角圖標',
        'appNameRequired': '應用名稱不能為空',
        'appNameIsExit': '應用名稱已被佔用',
        'ipRequired': '請添加訪問IP'
    },
    // 安全连接翻译开始
    '安全链接': '安全鏈接',
    '链接安全管控': '鏈接安全管控',
    '管控目录的文件': '管控目錄的文件',
    '如果允许管控目录内的文件移动或复制，会导致文件不受此规则管控': '如果允許管控目錄內的文件移動或復制，會導致文件不受此規則管控',
    '禁止移动': '禁止移動',
    '禁止复制': '禁止復制',
    '链接最长有效期': '鏈接最長有效期',
    '目录所在路径': '目錄所在路徑',
    '禁止重命名': '禁止重命名',
    '联系客服开通服务，请拨打 400-898-7968': '聯系客服開通服務，請撥打 400-898-7968',
    '如果管控目录所在路径被重命名，会导致此管控规则失效': '如果管控目錄所在路徑被重命名，會導致此管控規則失效',
    '目录链接管控规则': '目录链接管控规则',
    '规则说明': '規則說明',
    '添加管控规则': '添加管控規則',
    '管控白名单': '管控白名單',
    '天': '天',
    '年': '年',
    //sp2-start
    '禁止上传': '禁止上傳',
    '禁止下载': '禁止下載',
    '禁止预览': '禁止預覽',
    '仅内部成员可用': '僅內部成員可用',
    '最长有效期': '請輸入正整數',
    '请输入正整数': '請輸入正整數',
    '生成链接必须添加密码': '生成鏈接必須添加密碼',
    '最多阅读次数': '最多閱讀次數',
    '最长阅读时长': '最長閱讀時長',
    '文档只读': '文檔只讀',
    '禁止打印': '禁止打印',
    '失效后删除': '失效後刪除',
    '添加水印': '添加水印',
    '请输入水印': '請輸入水印',
    '取消': '取消',
    '确定': '確定' ,
    '提交': '提交',
    '暂无搜索结果': '暫無搜索結果',
    '子团队继承规则': '子團隊繼承規則',
    '最多可下载次数': '最多可下載次數',
    '还未配置规则': '還未配置規則',
    '您可以添加规则来限制网盘成员使用链接的设置项': '您可以添加規則來限制網盤成員使用鏈接的設置項',
    '没有相应的目录': '沒有相應的目錄',
    '白名单': '白名單',
    '管控目录': '管控目錄',
    '管控用户': '管控用戶',
    '创建者': '創建者',
    '审批者': '審批者',
    '创建时间': '創建時間',
    '操作': '操作',
    '设置': '設置',
    '删除': '刪除',
    '返回链接管控设置': '返回鏈接管控設置',
    '目录链接规则设置': '目錄鏈接規則設置',
    '点击或搜索目录名': '點擊或搜索目錄名',
    '企业空间': '企業空間',
    '设置普通链接管控': '設置普通鏈接管控',
    '设置安全链接管控': '設置安全鏈接管控',
    '次': '次',
    '小时': '小時',
    '所有用户': '所有用戶',
    '删除成功': '刪除成功',
    '删除失败': '刪除失敗',
    '管控规则已达上限': '管控規則已達上限',
    '提交成功': '提交成功',
    '提交失败': '提交失敗',
    '网络问题，请重新尝试提交': '網絡問題，請重新嘗試提交',
    '请输入': '請輸入',
    '水印': '水印',
    '请选择要管控的目录': '請選擇要管控的目錄',
    '请选择受管控的用户': '請選擇受管控的用戶',
    '请至少允许一项': '請至少允許壹項',
    '始终链接到文件最新版本': '始終鏈接到文件最新版本',
    '提示': '提示',
    '链接安全管控规则不会影响历史创建的安全链接，请检查历史链接是否存在安全风险！是否确认提交？': '連結安全管控規則不會影響歷史連結，請注意檢查歷史連結是否存在安全風險！是否確認提交？',
    '您确认要删除选中的管控规则吗？': '您確認要刪除選中的管控規則嗎？',
    '全局规则获取失败': '全局規則獲取失敗',
    '输入用户名或邮箱，添加白名单用户': '輸入用戶名或郵箱，添加白名單用戶',
    '白名单仅可以添加用户，被添加到白名单的用户不受到管控规则的影响。': '白名單僅可以添加用戶，被添加到白名單的用戶不受到管控規則的影響。',
    //sp2-end
    // 安全连接翻译结束
    //hover优化start
    '路径：': '路徑：',
    '邮箱：':'郵箱：',
    //hover优化end

    //文件夹加密start
    '名称': '名稱',
    '邮箱':'郵箱',
    '路径': '路徑',
    '管控成员设置成功':'管控成員設置成功',
    '管控规则设置成功':'管控規則設置成功',
    '还未添加管控成员':'還未添加管控成員',
    '添加白名单':'添加白名單',
    '搜索目录：':'搜索目錄：',
    '搜索用户：':'搜索用戶：',
    '管控规则：':'管控規則：',
    '添加管控白名单':'添加管控白名單',
    '所属团队':'所屬團隊',
    '请输入管控目录内的文件夹名称':'請輸入管控目錄內的文件夾名稱',
    '添加管控规则白名单：':'添加管控規則白名單：',
    '受管控成员白名单：':'受管控成員白名單：',
    '添加受控成员白名单':'添加受控成員白名單',
    '管控目录白名单：':'管控目錄白名單：',
    '审批目录白名单：':'審批目錄白名單：',
    '添加白名单目录':'添加白名單目錄',
    '还没有添加白名单目录':'還沒有添加白名單目錄',
    '还没有添加白名单':'還沒有添加白名單',
    '请选择一个管控目录':'請選擇一個管控目錄',
    '请添加受管控成员':'請添加受管控成員',
    '当前配置与历史配置规则冲突，重复配置将覆盖之前记录，是否需要覆盖？':'當前配置與歷史配置規則衝突，重複配置將覆蓋之前記錄，是否需要覆蓋？',
    '您的企业暂未开通此服务，如需开通功能请拨打客服电话：400-898-7968':'您的企業暫未開通此服務，如需開通功能請撥打客服電話：400-898-7968',
    '您的企业暂未开通此服务':'您的企業暫未開通此服務',
    '如需开通功能请拨打客服电话：400-898-7968':'如需開通功能請撥打客服電話：400-898-7968',
    '设置离线文档管控，会对下载到本地的敏感文档有更安全的保护':'設置離線文檔管控，會對下載到本地的敏感文檔有更安全的保護',
    '白名单设置成功':'白名單設置成功',
    '路径不存在':'路徑不存在',
    '已选择该目录':'已選擇該目錄',
    '可添加管控目录下的子目录不受管控规则限制':'可添加管控目錄下的子目錄不受管控規則限制',
    '添加失败，团队、组织或成员超出100条上限':'添加失敗，團隊、組織或成員超出100條上限',
    '添加失败，团队或成员超出100条上限':'添加失敗，團隊或成員超出100條上限',
    '已选择该用户':'已選擇該用戶',
    '选择的用户为白名单中的用户，管控将不会对此用户生效':'選擇的用戶為白名單中的用戶，管控將不會對此用戶生效',
    '选择的用户中存在白名单用户，管控将不会对此类用户生效':'選擇的用戶中存在白名單用戶，管控將不會對此類用戶生效',
    //文件夹加密end
    '管理员':'管理員',
    '团队管理员': '團隊管理員',
    '最多能设置5个审批者':'最多能設置5個審批者',
    '没有相应的成员':'沒有相應的成員',
    '常用': "Common",
    '设置成功':'設置成功',
    '设置失败':'設置失敗',
    '成功':'成功',
    '失败':'失敗',
    '受管控对象':'受管控對象',
    '全部成员':'全部成員',
    '共{0}项':'共{0}項',
    '链接审批规则':'鏈接審批規則',
    '默认审批者规则':'默認審批者規則',
    '添加审批规则':'添加審批規則',
    '全部受管控成员':'全部受管控成員',
    '添加管控':'添加管控',
    '还没有管控对象':'還沒有管控對象',
    '请选择链接审批者':'請選擇連結審批者',
    '受管控成员':'受管控成員',
    '链接审批设置':'連結審批設置',
    '选择的对象中存在白名单用户，审批规则将不会对此类用户生效':'選擇的對象中存在白名單用戶，審批規則將不會對此類用戶生效',
    '继续添加，该对象将受到离线文档管控的限制':'繼續添加，該對象將受到離線文檔管控的限制',
    '当前选择的对象中包含未在功能管控范围的对象':'當前選擇的對象中包含未在功能管控範圍的對象',
    '当前选择的对象未在功能管控对象范围内':'當前選擇的對象未在功能管控對象範圍內',
    '开启后仅能通过windows客户端下载网盘内文件，下载的文件将会加密，有效提升数据安全性':'開啟後僅能通過windows客戶端下載網盤內文件，下載的文件將會加密，有效提升數據安全性',
    '不加入IP访问限制': '不加入IP訪問限制',
    '管理员可设定访问网盘的IP地址限制': '管理員可設定訪問網盤的IP位址限制',
    '不勾选该项，需通过访问管理指定的IP地址访问网盘': '不勾選該項，需通過訪問管理指定的IP位址訪問網盤',
    '勾选该项的用户/团队，则该用户/团队访问网盘不受IP地址限制': '勾選該項的用戶/團隊，則該用戶/團隊訪問網盤不受IP位址限制s',
    '添加审批规则白名单':'添加審批規則白名單',
};





// WEBPACK FOOTER //
// ./static/js/language/tw.js